import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './SideMenu.css'; // Include the CSS for the styles
import { FaUser, FaChartLine, FaUsers, FaSignOutAlt, FaBars, FaCog, FaTimes } from 'react-icons/fa'; // Icons from react-icons

const SideMenu = () => {
  const navigate = useNavigate();
  const [isCollapsed, setIsCollapsed] = useState(false); // State to track the collapsed state of the menu
  const [isSettingsOpen, setIsSettingsOpen] = useState(false); // State to track settings dropdown visibility


  const usertype = localStorage.getItem('usertype'); // Example: 'Admin', 'Team', etc.


  const handleLogout = () => {
    navigate('/login'); // Redirect to the Login page
  };

  const toggleMenu = () => {
    setIsCollapsed((prevState) => !prevState); // Toggle menu collapsed state
  };

  const toggleSettings = () => {
    setIsSettingsOpen((prevState) => !prevState); // Toggle settings dropdown visibility
  };

  return (
    <aside className={`side-menu ${isCollapsed ? 'collapsed' : ''}`}>
      {/* Hamburger/Close Icon */}
      <div className="menu-header" onClick={toggleMenu}>
        {isCollapsed ? <FaBars className="menu-icon" /> : <FaTimes className="menu-icon" />}
      </div>

      {/* Menu Items */}
      <button className="button-64" role="button" onClick={() => navigate('/profile')}>
        <FaUser className="menu-icon" />
        {!isCollapsed && <span className="text">Profile</span>}
      </button>
      <button className="button-64" role="button" onClick={() => navigate('/sales-dashboard')}>
        <FaChartLine className="menu-icon" />
        {!isCollapsed && <span className="text">Sales</span>}
      </button>

      {/* Settings Button with Dropdown */}
      <div className="settings-container">
        <button className="button-64" role="button" onClick={toggleSettings}>
          <FaCog className="menu-icon" />
          {!isCollapsed && <span className="text">Settings</span>}
        </button>
        {!isCollapsed && isSettingsOpen && (
          <div className="settings-dropdown">

          {usertype === 'Super Admin' && (
            <button className="button-64" role="button" onClick={() => navigate('/user-access')}>
              <FaUsers className="menu-icon" />
              <span className="text">User Access</span>
            </button>
          )}
            <button className="button-64 logout-button" role="button" onClick={handleLogout}>
              <FaSignOutAlt className="menu-icon" />
              <span className="text">Logout</span>
            </button>
          </div>
        )}
      </div>
    </aside>
  );
};

export default SideMenu;
